import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import request from "../../../utilities/requests";
import formatDate from "../../../utilities/formatDate";

const RegisteredEvents = ({ open, close, user }) => {
  const navigate = useNavigate();
  const [events, setEvents] = React.useState([]);

  React.useEffect(() => {
    if (user) {
      getEvents(user._id);
    }
  }, [user]);

  const getEvents = async (userId) => {
    const result = await request(`events/admingetevents?userId=${user._id}`);
    if (result.success) {
      setEvents(result.events);
    }
  };

  const handleEventClick = (event) => {
    if (event.eventType === "Pairing") {
      navigate("/eventcontroller", { state: { event } });
    }
  };

  const renderEvents = () => {
    if (events.length === 0) {
      return <Typography>No Events</Typography>;
    }
    return events.map((event, i) => {
      return (
        <ListItem
          key={`${i}-${event._id}`}
          style={{ cursor: "pointer" }}
          onClick={() => handleEventClick(event)}
        >
          {event?.name} | {formatDate(event?.date)}
        </ListItem>
      );
    });
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle id="alert-dialog-title">
        {`Registered Events for ${user?.profile?.firstName}`}
      </DialogTitle>
      <DialogContent>
        <List>{renderEvents()}</List>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegisteredEvents;
